import script from "./ResultadoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoCard.vue?vue&type=script&setup=true&lang=js"

import "./ResultadoCard.vue?vue&type=style&index=0&id=4db67d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db67d88"]])

export default __exports__